import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { constants, links, snowplow } from 'common/helpers'
import actions from 'redux/actions'
import { intlMessageShape, FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import s from './PreparingDowngradeModal.scss'
import messages from './messages'


const placement = 'preparing downgrade popup'

class PreparingDowngradeModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      text: PropTypes.shape(intlMessageShape),
      btnTitle: PropTypes.shape(intlMessageShape),
    }),
  }

  static defaultProps = {
    name: constants.modals.PreparingDowngrade,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  handleClick = () => {
    const { data: { isPaused } } = this.props

    if (isPaused) {
      snowplow.track(constants.snowplowEvents.unpauseClick, { placement }, false)
      actions.models.subscription.unpause({ placement })
    }
    else {
      actions.models.subscription.setDowngrade(true)
      actions.models.router.push(links.cardUpdate)
    }

    this.close()
  }

  render() {
    const { name, data: { btnTitle, text } } = this.props

    return (
      <Modal name={name}>
        <FormattedMessage tag="div" {...text} />
        <Button
          className={s.button}
          title={btnTitle}
          onClick={this.handleClick}
          lg
          brand
        />
      </Modal>
    )
  }
}


export default connect({
  data: (state) => {
    const { models: { subscription: { isPaused } } } = state
    // if isUnpaid
    const data = {
      btnTitle: messages.btnUnpaid,
      text: messages.textUnpaid,
    }

    if (isPaused) {
      data.btnTitle = messages.btnUnpause
      data.text = messages.textUnpause
      data.isPaused = isPaused
    }

    return data
  },
})(PreparingDowngradeModal)
